
import { Component, Vue, Prop } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class TInputCloseBtn extends Vue {
  @Prop(String) public value: string;

  get searchValue() {
    return this.value;
  }

  set searchValue(value) {
    this.$emit('input', value);
  }
}
